module.exports = __webpack_public_path__ + "static/media/60.16705fa7.jpg";